import axios from 'axios';
import useUtils from "../../components/hooks/useUtils";

const { setCurUserId } = useUtils();

const state = {
	user: {},
	firm: {},
	users: [],
	admins: [],
	requests: [],
	userRequests: [],
	success: false,
	loading: false,
	message: "",
	locales: [
		{label: 'DE', value: 'de'},
		{label: 'EN', value: 'en'},
		{label: 'FR', value: 'fr'},
		{label: 'IT', value: 'it'}
	],
	localeChanged: false,
}

const mutations = {
	UPDATE_SAVEUSER(state, payload) {
		if (payload.success) {
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_ADMINS(state, payload) {
		state.admins=payload;
	},
	UPDATE_USERS(state, payload) {
		state.users=payload;
	},
	UPDATE_FIRMREQUESTS(state, payload) {
		state.requests=payload;
	},
	UPDATE_REQUESTS(state, payload) {
		state.userRequests = payload.data.requests;
	},
	UPDATE_LOADUSER(state, payload) {
		state.user = payload.data.user;
		state.firm = payload.data.firm;
		setCurUserId(state.user.user_id)
		setSuccessState(state);
	},
	UPDATE_LOADFIRM(state, payload) {
		if (payload.success) {
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
		state.firm = payload.data;
	},
	UPDATE_LOADING(state) {
		setLoadingState(state);
	},
	UPDATE_ERROR(state, payload) {
		setErrorState(state, payload);
	},
	UPDATE_LOCALE_CHANGED(state, payload) {
		state.localeChanged = payload;
	},
}

const actions = {
	//save new admin user and firm
	onboarding({ commit }, userData) {
		commit('UPDATE_LOADING');
		axios.post('/onboarding', userData)
		.then((response) => {
			commit('UPDATE_SAVEUSER', response.data)
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	//save new user
	store({ commit }, userData) {
		commit('UPDATE_LOADING');
		axios.post('/user/store', userData)
		.then((response) => {
			commit('UPDATE_SAVEUSER', response.data)
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	// load current user
	loadCurrentUser({ commit }, userId) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			const urlUserId = (userId != undefined) ? '/' + userId : "";
			axios.get('/user/load_current' + urlUserId)
			.then((response) => {
				commit('UPDATE_LOADUSER', response.data);
				commit('UPDATE_LOCALE_CHANGED', true);
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject(error);
			});
		});
	},
	// update user
	update({ commit }, userData) {
		commit('UPDATE_LOADING');
		axios.post('/user/update', userData)
		.then((response) => {
			commit('UPDATE_SAVEUSER', response.data)
			commit('UPDATE_LOCALE_CHANGED', true)
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	// update firm logo
	upload_logo({ commit }, userData) {
		commit('UPDATE_LOADING');
		axios.post('/logo/upload', userData)
		.then((response) => {
			commit('UPDATE_SAVEFIRM', response.data)
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	admins({ commit }) {
		if (!state.admins.length) {
			axios.get('/users/admins')
			.then((response) => {
					commit('UPDATE_ADMINS', response.data)
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
			});
		}
	},
	users({ commit }, filter) {
		return new Promise((resolve, reject) => {
			axios.get('/users/firmId/'+filter.firmId+'/role/'+filter.role)
			.then((response) => {
				commit('UPDATE_USERS', response.data)
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	firmRequests({ commit }, firmId) {
		return new Promise((resolve, reject) => {
			axios.get('/users/requests/firmId/'+firmId)
			.then((response) => {
				commit('UPDATE_FIRMREQUESTS', response.data)
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	requests({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get('/users/requests')
			.then((response) => {
				commit('UPDATE_REQUESTS', response.data)
				resolve();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	sendSetPasswordEmail({ commit }, userId) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios.get('/user/send_set_password_email/'+userId)
			.then((response) => {
				commit('UPDATE_SAVEUSER', response.data)
				response.data.success ? resolve() : reject();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	loadFirm({ commit }, name) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios.get('/firm/name/'+name)
			.then((response) => {
				commit('UPDATE_LOADFIRM', response.data);
				(response.data.success && response.data.data!="") ? resolve() : reject();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	update_consented({ commit }, user) {
		commit('UPDATE_LOADING');
		return new Promise((resolve, reject) => {
			axios.post('/user/update_consented', user)
			.then((response) => {
				commit('UPDATE_SAVEUSER', response.data);
				(response.data.success) ? resolve() : reject();
			})
			.catch(function(error) {
				commit('UPDATE_ERROR', error);
				reject();
			});
		});
	},
	update_locale({ commit }, user) {
		axios.put('/user/'+user.kc_user_id+'/locale/'+user.locale)
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
}

const getters = {
	user: state => state.user,
	firm: state => state.firm,
	users: state => state.users,
	admins: state => state.admins,
	requests: state => state.requests,
	userRequests: state => state.userRequests,
	success: state => state.success,
	loading: state => state.loading,
	message: state => state.message,
	locales: state => state.locales,
	localeChanged: state => state.localeChanged,
}

function setLoadingState(state) {
	state.success = false;
	state.loading = true;
	state.message = "";
}

function setSuccessState(state, message = "") {
	state.success = true;
	state.loading = false;
	state.message = message;
}

function setErrorState(state, message = "") {
	state.success = false;
	state.loading = false;
	state.message = message;
}

const userModule = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}

export default userModule;
